module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm3_m_en.1b2a39711e5617b65eca1d97ef30258b.png";